import { render } from "./data-notify.vue?vue&type=template&id=e618c4b4"
import script from "./data-notify.vue?vue&type=script&lang=js"
export * from "./data-notify.vue?vue&type=script&lang=js"

import "./data-notify.vue?vue&type=style&index=0&id=e618c4b4&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__